<template>
    <div class="container">

        <div class="row distance">
            <div class="five columns">
                <h2>Impressum</h2>

                <p> &nbsp; </p>
                <p><span class='lead'>Angaben gemäß § 5 TMG:</span><br />
                    Nikolai Müller<br />
                    Einsteinstraße 5<br />
                    82152 Planegg<br />
                </p>

                <p> &nbsp; </p>
                <p><span class='lead'>Kontakt:</span><br />
                    Telefon: +49-89-3108475<br />
                    E-Mail: <!-- $$$ Dotfuscate Email !!! -->
                    <!-- eslint-disable-next-line -->
                    <span v-for="item in dabla">{{item}}</span>
                </p>
                <p> &nbsp; </p>
                <p><span class='lead'>Umsatzsteuer-ID:</span><br />
                    Umsatzsteuer-Identifikationsnummer gemäß §27a Umsatzsteuergesetz:
                    <!-- $$$ Dotfuscate USTID !!! -->
                    <!-- eslint-disable-next-line -->
                    <span v-for="item in bliblub">{{item}}</span>
                </p>
                <p> &nbsp; </p>
                <p><span class='lead'>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</span><br />
                    Nikolai Müller <br />
                    Einsteinstraße 5<br />
                    82152 Planegg
                </p>

                <!-- $$$ TODO: ist das wirklich notwendig?!
                <p> &nbsp; </p>
                <p><span class="lead">Streitschlichtung</span><br />
                    Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
                    -->
            </div>

            <div class="seven columns">
                <h2>Haftungsausschluss</h2>
                <p> &nbsp; </p>
                <p><span class='lead'>Haftung für Inhalte</span><br />
                Die Inhalte meiner Seiten habe ich mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit
                und Aktualität der Inhalte kann ich jedoch keine Gewähr übernehmen.
                Als Diensteanbieter bin ich gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den
                allgemeinen Gesetzen verantwortlich.
                Nach §§ 8 bis 10 TMG bin ich als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen
                zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
                Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
                Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich.
                Bei Bekanntwerden von entsprechenden Rechtsverletzungen werde ich diese Inhalte umgehend entfernen.</p>

                <p><span class='lead'>Haftung für Links</span><br />
                Mein Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte ich keinen Einfluss habe.
                Deshalb kann ich für diese fremden Inhalte auch keine Gewähr übernehmen.
                Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
                Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft.
                Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
                Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar.
                Bei Bekanntwerden von Rechtsverletzungen werde ich derartige Links umgehend entfernen.</p>

                <p><span class='lead'>Urheberrecht</span><br />
                Die durch mich, den Seitenbetreiber, erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht.
                Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
                schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
                Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet.
                Insbesondere werden Inhalte Dritter als solche gekennzeichnet.
                Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitte ich um einen entsprechenden Hinweis.
                Bei Bekanntwerden von Rechtsverletzungen werde ich derartige Inhalte umgehend entfernen.</p>
            </div>
        </div>

        <div class="row">
            <div class="twelve columns" style="text-align:center;">
                <!-- <p> &nbsp; </p> -->
                <small><i>Website Impressum erstellt durch <a href="http://www.impressum-generator.de">impressum-generator.de</a> von <a href="http://www.kanzlei-hasselbach.de/rechtsanwalt-arbeitsrecht-frankfurt/">Franziska Hasselbach</a></i></small>
                <br>&nbsp;
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'PageImpressum',
    data () {
        return {
            msg: 'Welcome to Your Vue.js App',
            dabla: [ 'nikolai', '.', 'mueller', '@', 'nikim', '.', 'de' ],
            bliblub: [ 'D' + 'E2' + '95' + '2' + '775' + '44' ] // DE295277544
        }
    }
}
</script>

<style>
.lead {
    font-weight: bold;
}
/* .container {
    padding-left: 24px;
    padding-right: 24px;
    padding-top: 12px;
    padding-bottom: 12px;
} */
</style>



// WEBPACK FOOTER //
// src/components/pages/PageImpressum.vue